// Pick localized field with PT fallback
export function pickLang<T>(pt: T | null | undefined, en: T | null | undefined, lang: "pt" | "en"): T | "" {
  if (lang === "en") {
    const v = en as any;
    if (v != null && v !== "" && !(Array.isArray(v) && v.length === 0)) return en as T;
  }
  return (pt ?? "") as T | "";
}
